import React from 'react';

const AlignLeftIcon = () => {
  return (
    <svg stroke="#000" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1H7C3.68629 1 1 3.68629 1 7V13" strokeWidth="1.5"></path>
    </svg>
  );
};

export default AlignLeftIcon;
